import { createSelector } from 'reselect';
import { ASS_REQUESTS } from '../constants/assistanceRequest.constants';
import { initialState } from '../reducers/assistanceRequest.reducer';

const selectState = state => state?.[ASS_REQUESTS] || initialState;

const selectAssistanceRequestsData = createSelector(
  selectState,
  state => state.get('data')
);

const selectAssistanceRequestsList = createSelector(
  selectAssistanceRequestsData,
  data => data.toList()
);

export const selectAssistanceRequests = createSelector(
  selectAssistanceRequestsList,
  requests => requests.sortBy(a => -a.get('time'))
);

export const selectAssistanceRequestsFetched = createSelector(
  selectState,
  state => state.get('fetched')
);

const selectAssistanceRequestsSortedById = createSelector(
  selectAssistanceRequestsList,
  requests => requests.sortBy(a => -a.get('id'))
);

export const selectOpenAssistanceRequests = createSelector(
  selectAssistanceRequestsSortedById,
  requests => requests.filter(a => a.isOpen)
);

export const selectActiveAssistantRequestId = createSelector(
  selectState,
  state => state.get('active')
);

export const selectShowAssistantRequestDialog = createSelector(
  selectState,
  state => state.get('showDialog')
);

export const selectAssistanceRequestTileConfig = createSelector(
  selectState,
  state => state.get('tileConfig')
);